import { ActionReducerMap, MetaReducer } from '@ngrx/store';
import { PaceState } from '@evorait/pace-core';
import { environment } from '../../../environments/environment';

export const reducers: ActionReducerMap<PaceState> = {};

export const metaReducers: Array<MetaReducer<PaceState>> = !environment.production ? [] : [];
